import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { Formik, useField, useFormikContext } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';


export default function Create() {
    const navigate = useNavigate();
    const [ users, setUsers ] = useState([]);
    const [ from, onFromChange ] = useState(new Date());
    const [ to, onToChange ] = useState(new Date());
    const userRef = useRef();
    const departmentRef = useRef();
    const doctorRef = useRef();
    const descriptionRef = useRef();
    const fromRef = useRef();
    const toRef = useRef();


    const GetUsers = useCallback(() => { 
        axios.get('http://localhost:5000/Users/AllUsers')
            .then((response) => { 
                setUsers(response.data);
            })
            .catch((error) => { 
              
            });
    }, [users]);

    useEffect(() => { 
        GetUsers();
    });

    useEffect(() => { 
        GetUsers();
    }, [users]);

    return (
        <React.Fragment>
            <main>
                <h1>Create Appointment</h1>
                <span>
                <Link to="/Admin/Appointments" className="btn btn-secondary">Back</Link>
                </span>
                <section>
                    
                    <article>
                        <Formik 
                            initialValues={{ userId: '', location: '', doctor: '', department: '', from: '', to: '' }}
                            onSubmit={(values, { setSubmitting }) => { 
                                let data = { 
                                    user: userRef.current.value, 
                                    department: departmentRef.current.value,
                                    doctor: doctorRef.current.value, 
                                    description: descriptionRef.current.value, 
                                    fromTime: from,
                                    toTime: to,
                                }
                                axios.post('http://localhost:5000/Appointments/CreateAppointment', data)
                                    .then((response) => { 
                                        if (response.status === 200) { 
                                            navigate('/Admin/Appointments');
                                        }
                                    })
                                    .catch((error) => { 
                                        console.log(error);
                                    })
                            }}
                        >
                            {({
                                values, 
                                errors, 
                                touched, 
                                handleChange, 
                                handleBlur, 
                                handleSubmit, 
                                isSubmitting
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="formContainer">
                                        <label htmlFor="userId">Patient:</label>
                                        <select name="user" onChange={handleChange} onBlur={handleBlur} value={values.user} ref={userRef}>
                                            {
                                                [...Array((users.length))].map((e, i) => 
                                                    <option key={i} value={users[i]._id}>{users[i].email}</option>
                                                )
                                            }
                                        </select>
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="department">Department:</label>
                                        <select name="department" onChange={handleChange} onBlur={handleBlur} value={values.department} ref={departmentRef}>
                                            <option value="Diagnostic Imaging">Diagnostic Imaging</option>
                                            <option value="Ear, Nose and Throat">Ear, Nose and Throat</option>
                                            <option value="General Surgery">General Surgery</option>
                                            <option value="Haematology">Haematology</option>
                                            <option value="Neurology">Neurology</option>
                                        </select>
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="doctor">Doctor:</label>
                                        <select name="doctor" onChange={handleChange} onBlur={handleBlur} value={values.doctor} ref={doctorRef}>
                                            <option value="Dr Lewis Zimmerman">Doctor Lewis Zimmerman</option>
                                            <option value="Doctor Leonard McCoy">Doctor Leonard MacCoy</option>
                                            <option value="Doctor Beverley Crusher">Doctor Beverley Crusher</option>
                                            <option value="Doctor Julian Bashir">Doctor Julian Bashir</option>
                                        </select>
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="description">Description:</label>
                                        <textarea name="description" onChange={handleChange} onBlur={handleBlur} values={values.description} ref={descriptionRef}></textarea>
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="from">From:</label>
                                       <DateTimePicker name="from" value={from} onChange={onFromChange} />
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="to">To:</label>
                                        <DateTimePicker name="to" value={to} onChange={onToChange} />
                                    </div>
                                    <button type="submit">Submit</button>
                                </form>

                            )}
                        </Formik>
                    </article>
                </section>
            </main>
        </React.Fragment>
    )
}